/**
 * Helper functions for Profile components
 */

/**
 * Get only the fields that have changed between two objects
 */
export const getChangedFields = (current, initial) => {
  const changedFields = {}

  Object.keys(current).forEach((key) => {
    if (current[key] !== initial[key]) {
      changedFields[key] = current[key]
    }
  })

  return changedFields
}

/**
 * Handle input change for form fields
 */
export const handleInputChangeHelper = (event, setFormData) => {
  const { name, value, type, checked } = event.target

  setFormData((prevData) => ({
    ...prevData,
    [name]: type === 'checkbox' ? checked : value,
  }))
}

/**
 * Handle autocomplete change for form fields
 */
export const handleAutocompleteChange = (fieldName, value, setFormData) => {
  setFormData((prevData) => ({
    ...prevData,
    [fieldName]: value,
  }))
}

/**
 * Validate email format
 */
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

/**
 * Validate phone number format
 */
export const isValidPhone = (phone) => {
  // Remove all non-digit characters
  const digitsOnly = phone.replace(/\D/g, '')
  // Check if it has 10 or 11 digits (US format)
  return digitsOnly.length === 10 || digitsOnly.length === 11
}

/**
 * Format phone number for display
 */
export const formatPhoneNumber = (phone) => {
  if (!phone) return ''
  const digitsOnly = phone.replace(/\D/g, '')

  if (digitsOnly.length === 10) {
    return `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6)}`
  }

  return phone
}

/**
 * Clear a specific field error
 */
export const clearFieldError = (fieldName, setErrors) => {
  setErrors((prevErrors) => {
    const newErrors = { ...prevErrors }
    delete newErrors[fieldName]
    return newErrors
  })
}
